import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-communication-calendar-event-widget',
  templateUrl: './communication-calendar-event-widget.component.html',
  styleUrls: ['./communication-calendar-event-widget.component.scss']
})
export class CommunicationCalendarEventWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
